export default __webpack_public_path__ + "static/media/1902.9339a1af.png";